export const HANDLE_ON_CHANGE = 'HANDLE_ON_CHANGE';
export const Handle_Loading = 'Handle_Loading';
export const HANDLE_ON_CHANGE_OBJECT = 'HANDLE_ON_CHANGE_OBJECT';
export const Handle_Signup_Clear = 'Handle_Signup_Clear';